import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "../Components/LandingPage/LandingPage";
import ProductPage from "../Components/ProductPage/ProductPage";
import About from "../Components/About/About";
import Contact from "../Components/Contact/Contact";
import ProductDescription from "../Components/ProductDescription/ProductDescription";
import { useSelector } from "react-redux";
import ProductCategory from "../Components/ProductCategory/ProductCategory";

function AllRoutes() {
  const isLogin = useSelector((store) => store.loginStatus);
  const cartLen = useSelector((store) => store.cart.length);

  console.log(cartLen);

  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/shop" element={<ProductPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/details/:id" element={<ProductDescription />} />
        <Route path="/category/:type" element={<ProductCategory />} />
      </Routes>
    </>
  );
}

export default AllRoutes;
